export const COOKIE_KEYS = {
  TOKEN: 'clientToken',
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
};

export const QUERY_PARAMS = {
  TOKEN: 'token',
  EMAIL: 'email',
};
